import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";

import "./index.css";

import { HelmetProvider } from "react-helmet-async";

import App from "./App";
import "./i18n";
import { Loading } from "./components";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <HelmetProvider>
    <Suspense fallback={<Loading />}>
      <App />
    </Suspense>
  </HelmetProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
